import React from "react";
import { useSelector } from "react-redux";
import { createStructuredSelector } from "reselect";
import Form, {
  SimpleItem,
  GroupItem,
  RequiredRule,
  ButtonItem,
} from "devextreme-react/form";
import {
  selectEmployees,
  selectReasonCodes,
} from "../../redux/cash-in-out/cash-in-out-selectors";

const CashInOutFilter = ({ formData, handleSubmit }) => {
  const { employees, reasonCodes } = useSelector(
    createStructuredSelector({
      employees: selectEmployees,
      reasonCodes: selectReasonCodes,
    })
  );

  const buttonOptions = {
    useSubmitBehavior: true,
    stylingMode: "contained",
    type: "default",
    text: "Get report",
    elementAttr: { style: "background-color: #0737a0" },
  };

  return (
    <div className="mt-4">
      <div className="report-selector">
        <form onSubmit={handleSubmit}>
          <Form labelLocation="top" formData={formData}>
            <GroupItem colCount={2}>
              <SimpleItem
                dataField="startDate"
                editorType="dxDateBox"
                editorOptions={{
                  type: "date",
                  showClearButton: true,
                  pickerType: "calender",
                  useMaskBehavior: true,
                  displayFormat: "EEEE, dd MMM, yyyy",
                }}
              >
                <RequiredRule message="Start date is required" />
              </SimpleItem>
              <SimpleItem
                dataField="endDate"
                editorType="dxDateBox"
                editorOptions={{
                  type: "date",
                  pickerType: "calender",
                  showClearButton: true,
                  useMaskBehavior: true,
                  displayFormat: "EEEE, dd MMM, yyyy",
                }}
              >
                <RequiredRule message="End date is required" />
              </SimpleItem>
            </GroupItem>
            <GroupItem colCount={2}>
              <SimpleItem
                dataField="employee"
                editorType="dxSelectBox"
                editorOptions={{
                  showClearButton: true,
                  dataSource: employees,
                  displayExpr: "employeeName",
                  valueExpr: "employeeID",
                  placeholder: "Select employee",
                  searchEnabled: true,
                }}
              ></SimpleItem>
              <SimpleItem
                dataField="reason"
                editorType="dxSelectBox"
                editorOptions={{
                  showClearButton: true,
                  dataSource: reasonCodes,
                  displayExpr: "name",
                  valueExpr: "reasonID",
                  placeholder: "Select reason",
                  searchEnabled: true,
                }}
              ></SimpleItem>
            </GroupItem>
            <ButtonItem
              horizontalAlignment="left"
              buttonOptions={buttonOptions}
            />
          </Form>
        </form>
      </div>
    </div>
  );
};

export default CashInOutFilter;
